module.exports = __webpack_public_path__ + "images/backgrounds/snow/full.d5dd0a98d6b0a7ebcaff.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow/full.jpg
// module id = nqLk
// module chunks = 13